"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Form, InputNumber, Row, Select, Switch, Tooltip } from "antd";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { BOM } from "../../../services/definedMethod";

const CollateralValuation = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    currencyOptions,
    valuationMethodOptions,
  } = props;
  console.log(currencyOptions);

  const valuationInitialValues = {
    periodicRevaluation: false,
    historicalTracking: false,
    ...initialValues,
  };

  const handleFinish = (values) => {
    onFinish({
      ...values,
      periodicRevaluation: values.periodicRevaluation ?? false,
      historicalTracking: values.historicalTracking ?? false,
    });
  };

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Collateral Valuation
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={handleFinish}
        form={form}
        initialValues={valuationInitialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Currency
                  <Tooltip title="Select the currency">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="currencyCode"
              rules={[
                {
                  required: true,
                  message: "Please select currency",
                },
              ]}
            >
              <Select
                placeholder="Select currency"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={currencyOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Collateral Nominal Value
                  <Tooltip title="Enter the nominal value of the collateral">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="nominalValue"
              rules={[
                {
                  required: true,
                  message: "Collateral nominal value is required",
                },
              ]}
            >
              <InputNumber
                className="bond-input"
                style={{ height: 44, width: "100%" }}
                placeholder="0"
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Valuation Method
                  <Tooltip title="Select valuation method">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="valuationMethods"
              rules={[
                {
                  required: true,
                  message: "Please select valuation method",
                },
              ]}
            >
              <Select
                placeholder="Select valuation method"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={valuationMethodOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Periodic Revaluation
                  <Tooltip title="Enable periodic revaluation">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="periodicRevaluation"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Historical Valuation Tracking
                  <Tooltip title="Enable historical valuation tracking">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="historicalTracking"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CollateralValuation;
